import { deviceSystemAgeOptions } from "constants/DeviceSystemAgeOptions"
import {
  contractorPerformanceTestStatusOptions,
  deviceAccessoriesOptions,
  devicesAlertsOptions,
  devicesMembershipOptions,
  deviceSystemTypeOptions,
  deviceWorkStatusOptions,
  hvacOptions,
} from "constants/SelectFieldOptions"
import { UITypes } from "types"

import { CustomerMembershipType } from "components/table/columnComponents/CustomerMembershipType"
import { CustomerName } from "components/table/columnComponents/CustomerName"
import PerformanceTestScheduleDate from "components/table/columnComponents/PerformaceTestScheduleDate"
import { StatusOfPerformanceTest } from "components/table/columnComponents/StatusOfPerformanceTest"
import { StatusOfWork } from "components/table/columnComponents/StatusOfWork"
import { TempChangeOfPerformanceTest } from "components/table/columnComponents/TempChangeOfPerformanceTest"

const performanceTestTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "",
    size: "mini",
    name: "checkbox",
    type: "checkbox",
    cellComponent: "checkbox",
  },
  {
    title: "Email",
    type: "sort-search",
    name: "email",
    size: "middle",
  },
  {
    title: "Status",
    type: "select",
    name: "perftest_status",
    size: "small",
    options: contractorPerformanceTestStatusOptions,
    cellComponent: StatusOfPerformanceTest,
  },
  {
    title: "Temp change",
    type: "default",
    name: "temp_change",
    size: "middle",
    cellComponent: TempChangeOfPerformanceTest,
  },
  {
    title: "Schedule",
    type: "default",
    name: "perftest_schedule",
    size: "small",
    cellComponent: PerformanceTestScheduleDate,
  },
  {
    title: "Work status",
    type: "select",
    name: "work_status",
    size: "small",
    options: deviceWorkStatusOptions,
    cellComponent: StatusOfWork,
  },
  {
    title: "Label",
    type: "sort-search",
    name: "perftest_label",
    size: "small",
  },
  {
    title: "Country",
    type: "sort-search",
    name: "country",
    size: "small",
  },
  {
    title: "City",
    type: "sort-search",
    name: "city",
    size: "small",
  },
  {
    title: "ZIP code",
    type: "sort-search",
    name: "zip_code",
    size: "small",
  },
  {
    title: "State",
    type: "sort-search",
    name: "state",
    size: "small",
  },
  {
    title: "Customer",
    type: "sort-search",
    name: "homeowner_name",
    size: "middle",
    cellComponent: CustomerName,
  },
  {
    title: "Device S/N",
    type: "sort-search",
    name: "sn",
    size: "small",
  },
  {
    title: "Address",
    type: "sort-search",
    name: "address",
  },
  {
    title: "Installation type",
    type: "select",
    size: "small",
    name: "installation_type",
    options: hvacOptions,
  },
  {
    title: "Alerts",
    type: "select",
    size: "small",
    name: "alerts",
    options: devicesAlertsOptions,
  },
  {
    title: "Membership",
    type: "select",
    name: "membership",
    options: devicesMembershipOptions,
    size: "small",
  },
  {
    title: "Membership type",
    type: "search",
    name: "membership_name",
    size: "middle",
    cellComponent: CustomerMembershipType,
  },
  {
    title: "System type",
    type: "select",
    size: "small",
    name: "system_type",
    options: deviceSystemTypeOptions,
  },
  {
    title: "System age",
    type: "select",
    name: "system_age",
    options: deviceSystemAgeOptions,
    size: "middle",
  },
  {
    title: "Accessories",
    type: "select",
    size: "small",
    name: "accessories",
    options: deviceAccessoriesOptions,
  },
]

export default performanceTestTableHeaderCells
